import { render, staticRenderFns } from "./Play_Players.vue?vue&type=template&id=6ed7827f&scoped=true"
import script from "./Play_Players.vue?vue&type=script&lang=js"
export * from "./Play_Players.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed7827f",
  null
  
)

export default component.exports